import React from "react";
import { connect } from "react-redux";
import CurrencyFormatter from "currency-formatter";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import { updateHDEAnalysis, updateSDEAnalysis } from "../../../../store/modules/qualityOfEarnings/actions";

function Item({ name, bold, manuality, currentCompanyHDEAnalysis, dispatchUpdate }) {
  const objectName = (manuality ? "manual" : "total") + name.replace(/Total|[ &-]/g, "")
    + (currentCompanyHDEAnalysis.percentage ? "Margin" : "");   //we put prefix manual for manual inputs
  const manualInput = manuality && !currentCompanyHDEAnalysis.percentage;   //when it is percentage, we don't allow manual input

  return (
    <div className={`flex items-center ${bold ? "font-semibold" : ""} ${manualInput ? "mt-1" : "mt-5"}`}>
      <div className="whitespace-nowrap flex items-center" style={{ minWidth: "18em" }}>
        {name.startsWith("Total") ? name.replace(/Owner |Over & Under /g, "") : name}
      </div>
      <div className="flex">
        {currentCompanyHDEAnalysis[objectName]?.map((obj, index) => manualInput ?
          <div className="flex" style={{ width: "10em" }}>
            <BVAInput
              startAdornment
              startAdornmentLabel="$ "
              width="95%"
              size="small"
              key={index}
              value={obj.value}
              onChange={(value) => dispatchUpdate("MANUAL", value, index, objectName, index)}
            />
          </div>
          :
          <div className="flex" style={{ minWidth: "10em" }}>
            <div style={{ minWidth: "1.3em" }} />
            {CurrencyFormatter.format(
              currentCompanyHDEAnalysis.percentage ? obj?.value * 100 : obj?.value,
              { code: currentCompanyHDEAnalysis.percentage ? "" : "USD" }
            )}
            {currentCompanyHDEAnalysis.percentage ? "%" : ""}
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyHDEAnalysis: state.qualityOfEarnings.currentCompanyHDEAnalysis,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdate(label, value, id, type, key) {
    dispatch(updateHDEAnalysis(label, value, id, type, key));
    dispatch(updateSDEAnalysis(label, value, id, type, key));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Item);